import React, { useState, useEffect } from "react";
import { Box, Button, Typography, useTheme, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { resolvePath, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Searchbox from "../../components/Searchbox";
import ModalWithTabs from "../../components/modals/ModalWithTabs";
import WarningModal from "../../components/modals/WarningModal";
import UploadSpreadSheetModal from "../../components/modals/UploadSpreadSheetModal";
import MoreFormModal from "../../components/modals/MoreFormModal";
import CreateWalletModal from "../../components/modals/CreateWalletModal";
import CreateAccountModal from "../../components/modals/CreateAccountModal";
import MultipleFormModal from "../../components/modals/MultipleFormModal";
import { format } from "date-fns";

const SEARCH_BY_EMAIL = "/auth-service/api/v1/user/email/";
const SEARCH_BY_PHONE = "/auth-service/api/v1/user/phone/";

const ACCOUNT_REGEX = /^\d{10}$/;
const ID_REGEX = /^\d{1,4}$/;
const CUSTOMER_ID_REGEX = /^(INDV|CORP)\d+$/i;

const ManageUser = () => {
  const theme = useTheme();
  const { queryUserDetails, info, snackError, setQueryUserDetails, success } =
    useAuth();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [createUserAnchorEl, setCreateUserAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState({ open: false, title: "" });
  const [walletModal, setWalletModal] = useState({ open: false });
  const [multipleFormModal, setMultipleFormModal] = useState({
    open: false,
    title: "",
  });
  const [accountModal, setAccountModal] = useState({ open: false });
  const [spreadSheetModal, setSpreadSheetModal] = useState({
    open: false,
    title: "",
  });
  const open = Boolean(anchorEl);
  const createUserOpen = Boolean(createUserAnchorEl);
  const [{ action, url, openConfirm }, setConfirm] = useState({
    openConfirm: false,
    url: "",
    action: "",
  });

  // Filter States
  const [userType, setUserType] = useState("ALL");
  const [businessType, setBusinessType] = useState("ALL");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [kycStatusFilter, setKycStatusFilter] = useState("ALL");
  const [genderFilter, setGenderFilter] = useState("ALL");
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortDirection, setSortDirection] = useState("DESC");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState("");

  let { user } = queryUserDetails;

  const toggleMenu = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const toggleCreateUserMenu = (event) => {
    setCreateUserAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateUserClose = () => {
    setCreateUserAnchorEl(null);
  };

  const handleOption = async (e) => {
    setAnchorEl(null);
    let response, response2, response3;
    const targetUserId = selectedUser?.id || selectedUser?.userId || user[0]?.id || user[0]?.userId;

    if (e.target.textContent === "Manage Profile") {
      try {
        response = await axiosPrivate.get(
          "/auth-serviceV3/admin/users/" + targetUserId
        );

        response2 = await axiosPrivate.get(
          "/auth-serviceV3/api/v1/accounts/user/" + targetUserId + "/details"
        );

        setQueryUserDetails((prev) => {
          return {
            ...prev,
            manageProfile: response?.data?.data,
            transConfig: response2?.data?.data,
          };
        });
        navigate("/update_user");
      } catch (error) {
        snackError(error?.response?.data?.message);
      }
    } else if (e.target.textContent === "Manage Accounts") {
      try {
        response = await axiosPrivate.get(
          "/transaction-payment/api/v1/admin/transactions/user/" + targetUserId,
          {
            params: {
              page: 0,
              size: 5,
            },
          }
        );
        response2 = await axiosPrivate.get(
          "/auth-serviceV3/api/v1/accounts/user/" + targetUserId + "/details"
        );
        // response3 = await axiosPrivate.get(
        //   "/card-service/card/list/" + targetUserId
        // );
        // console.log(response3);
        setQueryUserDetails((prev) => {
          return {
            ...prev,
            manageAccount: response2?.data?.data,
            manageTransaction: response?.data?.data,
          };
        });
        setIsOpen(true);
      } catch (error) {
        snackError(error?.response?.data?.message);
      }
    } else if (e.target.textContent === "Block User") {
      setConfirm({
        url: "/auth-service/api/v1/admin/users/lock-toggle/un-lock",
        openConfirm: true,
        action: "block",
      });
    } else if (e.target.textContent === "Unblock User") {
      setConfirm({
        url: "/auth-service/api/v1/admin/users/lock-toggle/un-lock",
        openConfirm: true,
        action: "unblock",
      });
    } else if (e.target.textContent === "Deactivate User") {
      setConfirm({
        url: "/auth-serviceV3/admin/users/" + targetUserId + "/active",
        openConfirm: true,
        action: "deactivate",
      });
    } else if (e.target.textContent === "Activate User") {
      setConfirm({
        url: "/auth-serviceV3/admin/users/" + targetUserId + "/active",
        openConfirm: true,
        action: "activate",
      });
    } else if (e.target.textContent === "Reset Credential") {
      setConfirm({
        url: "/auth-service/api/v1/password/change-password/byEmail",
        openConfirm: true,
        action: "reset",
      });
    } else if (e.target.textContent === "Lock Transaction") {
      setConfirm({
        url: "/auth-service/api/v1/admin/users/lock-toggle/un-lock",
        openConfirm: true,
        action: "lock",
      });
    } else if (e.target.textContent === "Manage KYC") {
      try {
        response2 = await axiosPrivate.get(
          "/auth-serviceV3/admin/users/" + targetUserId
        );
        console.log({ response2 });
        setQueryUserDetails((prev) => {
          return { ...prev, manageKYC: response2?.data?.data };
        });
        navigate("/user_kyc");
      } catch (error) {
        snackError(error?.response?.data?.message);
      }
    } else if (e.target.textContent === "Login Tracker") {
      try {
        response = await axiosPrivate.get(
          "/audit-reporting/audit/events/search",
          {
            params: {
              userId: targetUserId,
              eventType: "USER_LOGIN",
              page: 0,
              size: 50,
              sortBy: "timestamp",
              sortDir: "desc"
            }
          }
        );
        const resData = response?.data;
        let contentList = [];
        if (resData) {
          if (Array.isArray(resData)) {
            contentList = resData;
          } else if (Array.isArray(resData?.data?.content)) {
            contentList = resData.data.content;
          } else if (Array.isArray(resData?.data)) {
            contentList = resData.data;
          } else if (Array.isArray(resData?.content)) {
            contentList = resData.content;
          }
        }
        setQueryUserDetails((prev) => {
          return { ...prev, loginTracker: contentList };
        });
        navigate("/login_tracker");
      } catch (error) {
        snackError(error?.response?.data?.message || "Failed to fetch login tracker history.");
      }
    } else if (e.target.textContent === "Activity Log") {
      navigate("/audit_reports", { state: { userId: targetUserId } });
    } else if (e.target.textContent === "Create Single User") {
      setModal({ open: true, title: e.target.textContent });
    } else if (e.target.textContent === "Upload Spread Sheet") {
      setSpreadSheetModal({ open: true, title: e.target.textContent });
    } else if (e.target.textContent === "Create Users with Forms") {
      setMultipleFormModal({ open: true, title: e.target.textContent });
    }
  };

  const handleSearch = async ({ searchKey }) => {
    if (!searchKey || searchKey.trim() === "") {
      setSearch("");
      setPage(1);
      return;
    }

    const trimmedKey = searchKey.trim();

    // If searching for exactly a 10-digit account number, fetch account/customer info
    if (trimmedKey.match(ACCOUNT_REGEX)) {
      try {
        const response = await axiosPrivate.get(
          `/audit-reporting/admin/customers/${trimmedKey}/account`
        );
        const result = response?.data?.data;
        if (result) {
          setQueryUserDetails((prev) => {
            return { ...prev, user: Array.isArray(result) ? result : [result] };
          });
          setTotalRows(Array.isArray(result) ? result.length : 1);
          setSearch(trimmedKey);
          setPage(1);
        } else {
          info("No customer found with that account number");
        }
      } catch (error) {
        snackError(error?.response?.data?.message || "Failed to fetch customer by account number.");
      }
    }
    // Otherwise, if searching for a 1-4 digit ID or a string customerId, query customer detail directly
    else if (trimmedKey.match(ID_REGEX) || trimmedKey.match(CUSTOMER_ID_REGEX)) {
      try {
        const response = await axiosPrivate.get(
          `/audit-reporting/admin/customers/${trimmedKey}`
        );
        const result = response?.data?.data;
        if (result) {
          setQueryUserDetails((prev) => {
            return { ...prev, user: Array.isArray(result) ? result : [result] };
          });
          setTotalRows(Array.isArray(result) ? result.length : 1);
          setSearch(trimmedKey);
          setPage(1);
        } else {
          info("No customer found with that ID");
        }
      } catch (error) {
        snackError(error?.response?.data?.message || "Failed to fetch customer by ID.");
      }
    } else {
      // Otherwise, trigger the general accounts/names search reactively
      setSearch(trimmedKey);
      setPage(1);
    }
  };

  const getUsers = async () => {
    const trimmedSearch = search ? search.trim() : "";
    // If searching for a specific account number or ID directly, handleSearch already fetched the data.
    // Avoid overwriting by returning early.
    if (trimmedSearch && (trimmedSearch.match(ACCOUNT_REGEX) || trimmedSearch.match(ID_REGEX) || trimmedSearch.match(CUSTOMER_ID_REGEX))) {
      return;
    }

    // If no search or filter has been applied yet, do not fetch any data
    const isSearchActive = search && search.trim() !== "";
    const isFilterActive =
      (userType && userType !== "ALL") ||
      (businessType && businessType !== "ALL") ||
      (statusFilter && statusFilter !== "ALL") ||
      (kycStatusFilter && kycStatusFilter !== "ALL") ||
      (genderFilter && genderFilter !== "ALL");

    if (!isSearchActive && !isFilterActive) {
      setQueryUserDetails((prev) => ({ ...prev, user: [] }));
      setTotalRows(0);
      return;
    }

    try {
      const payload = {
        page: page - 1,
        size: pageSize,
        sortBy,
        sortDirection,
      };

      if (userType && userType !== "ALL") {
        payload.userType = userType;
      }
      if (businessType && businessType !== "ALL" && userType === "CORPORATE") {
        payload.businessType = businessType;
      }
      if (statusFilter && statusFilter !== "ALL") {
        payload.status = statusFilter;
      }
      if (kycStatusFilter && kycStatusFilter !== "ALL") {
        payload.kycStatus = kycStatusFilter;
      }
      if (genderFilter && genderFilter !== "ALL") {
        payload.gender = genderFilter;
      }

      if (search) {
        const trimmed = search.trim();
        if (trimmed.includes("@")) {
          payload.email = trimmed;
        } else if (/^\d{11}$/.test(trimmed)) {
          // Exactly 11 digits: can be BVN, NIN, or Phone Number
          if (trimmed.startsWith("22")) {
            payload.bvn = trimmed;
          } else if (trimmed.startsWith("0")) {
            payload.phoneNumber = trimmed;
          } else {
            payload.nin = trimmed;
          }
        } else if (/^\+?\d{7,15}$/.test(trimmed)) {
          payload.phoneNumber = trimmed;
        } else {
          const parts = trimmed.split(/\s+/);
          if (parts.length > 1) {
            payload.firstName = parts[0];
            payload.lastName = parts.slice(1).join(" ");
          } else {
            // Only set firstName to avoid empty intersections on AND queries for lastName
            payload.firstName = trimmed;
          }
        }
      }

      let response = await axiosPrivate.post(
        "/auth-serviceV3/admin/users/search",
        payload
      );

      let result = response?.data?.data?.users || response?.data?.data?.content || response?.data?.data || [];

      // Self-healing fallback search for 11-digit numbers:
      if (result.length === 0 && search) {
        const trimmed = search.trim();
        if (/^\d{11}$/.test(trimmed)) {
          // If we tried phone number (starts with 0), try NIN next
          if (trimmed.startsWith("0")) {
            const fallbackPayload = { ...payload, phoneNumber: undefined, nin: trimmed };
            const fallbackResponse = await axiosPrivate.post(
              "/auth-serviceV3/admin/users/search",
              fallbackPayload
            );
            const fallbackResult = fallbackResponse?.data?.data?.users || fallbackResponse?.data?.data?.content || fallbackResponse?.data?.data || [];
            if (fallbackResult.length > 0) {
              result = fallbackResult;
              response = fallbackResponse;
            }
          }
          // If we tried NIN (not starting with 0 or 22), try BVN next
          else if (!trimmed.startsWith("22")) {
            const fallbackPayload = { ...payload, nin: undefined, bvn: trimmed };
            const fallbackResponse = await axiosPrivate.post(
              "/auth-serviceV3/admin/users/search",
              fallbackPayload
            );
            const fallbackResult = fallbackResponse?.data?.data?.users || fallbackResponse?.data?.data?.content || fallbackResponse?.data?.data || [];
            if (fallbackResult.length > 0) {
              result = fallbackResult;
              response = fallbackResponse;
            }
          }
        }
      }

      const total =
        response?.data?.data?.totalElements !== undefined ? response?.data?.data?.totalElements :
          response?.data?.data?.total !== undefined ? response?.data?.data?.total :
            response?.data?.total !== undefined ? response?.data?.total :
              (response?.data?.data?.totalPages ? response.data.data.totalPages * (response.data.data.pageSize || 10) : 0);
      setTotalRows(total);
      setQueryUserDetails((prev) => {
        return { ...prev, user: Array.isArray(result) ? result : [result] };
      });
    } catch (error) {
      console.log(error?.response?.data || error.message);
      snackError(error?.response?.data?.message || "Failed to fetch customers list.");
    }
  };

  useEffect(() => {
    getUsers();
  }, [
    userType,
    businessType,
    statusFilter,
    kycStatusFilter,
    genderFilter,
    sortBy,
    sortDirection,
    page,
    pageSize,
    search,
  ]);
  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: 50,
      renderCell: ({ row }) => (
        <Typography>
          {row.userId || row.id || "N/A"}
        </Typography>
      ),
    },
    {
      field: "firstName",
      headerName: "First Name",
      width: 100,
      cellClassName: "name-column--cell",
      renderCell: ({ row }) => {
        let name = row.firstName;
        if (!name && row.customerName) {
          name = row.customerName.split(" ")[0];
        }
        return (
          <Typography>
            {name || "N/A"}
          </Typography>
        );
      },
    },
    {
      field: "surname",
      headerName: "Last Name",
      width: 100,
      cellClassName: "name-column--cell",
      renderCell: ({ row }) => {
        let name = row.surname || row.lastName;
        if (!name && row.customerName) {
          name = row.customerName.split(" ").slice(1).join(" ");
        }
        return (
          <Typography>
            {name || "N/A"}
          </Typography>
        );
      },
    },
    {
      field: "dateOfBirth",
      headerName: "Date of Birth",
      headerAlign: "left",
      align: "left",
      renderCell: ({ row }) => (
        <Typography>
          {row.dateOfBirth || "N/A"}
        </Typography>
      ),
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      width: 120,
      renderCell: ({ row }) => (
        <Typography>
          {row.phoneNumber || row.phone || "N/A"}
        </Typography>
      ),
    },
    { field: "email", headerName: "Email", width: 200 },
    {
      field: "userType",
      headerName: "User Type",
      width: 100,
      cellClassName: "name-column--cell",
      renderCell: ({ row }) => {
        let type = row.userType;
        if (!type && row.corporate !== undefined) {
          type = row.corporate ? "CORPORATE" : "PERSONAL";
        }
        return (
          <Typography>
            {type || "N/A"}
          </Typography>
        );
      },
    },
    {
      field: "customerCategory",
      headerName: "Category",
      width: 130,
      renderCell: ({ row }) => {
        const category = row.customerCategory ? row.customerCategory.replace(/_/g, " ") : "N/A";
        return (
          <Typography>
            {category}
          </Typography>
        );
      },
    },
    {
      field: "active",
      headerName: "Status",
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: ({ row }) => {
        const isUserActive = row.isActive !== undefined ? row.isActive : (row.active !== undefined ? row.active : (row.status === "ACTIVE" || row.customerStatus === "ACTIVE"));
        return (
          <Typography
            color={isUserActive ? colors.greenAccent[400] : colors.redAccent[400]}
          >
            {isUserActive ? "active" : "inactive"}
          </Typography>
        );
      },
    },
    {
      field: "accountLocked",
      headerName: "Locked",
      type: "boolean",
      width: 70,
      renderCell: ({ row: { accountLocked } }) => (
        <Typography
          color={
            accountLocked ? colors.greenAccent[400] : colors.redAccent[400]
          }
        >
          {accountLocked ? accountLocked.toString() : "false"}
        </Typography>
      ),
    },
    {
      field: "accountDeleted",
      headerName: "Deleted",
      type: "boolean",
      width: 70,
      renderCell: ({ row: { accountDeleted } }) => (
        <Typography
          color={
            accountDeleted ? colors.greenAccent[400] : colors.redAccent[400]
          }
        >
          {accountDeleted ? accountDeleted.toString() : "false"}
        </Typography>
      ),
    },
    {
      field: "accountExpired",
      headerName: "Expired",
      type: "boolean",
      width: 70,
      renderCell: ({ row: { accountExpired } }) => (
        <Typography
          color={
            accountExpired ? colors.greenAccent[400] : colors.redAccent[400]
          }
        >
          {accountExpired ? accountExpired.toString() : "false"}
        </Typography>
      ),
    },
    {
      field: "createdAt",
      headerName: "Date Created",
      width: 130,
      cellClassName: "name-column--cell",
      renderCell: ({ row }) => (
        <Typography>
          {row.createdAt ? format(new Date(row.createdAt), "yyyy-MM-dd HH:mm") : "N/A"}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 60,
      align: "center",
      renderCell: ({ row }) => {
        const handleActionsClick = (event) => {
          setSelectedUser(row);
          toggleMenu(event);
        };

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              boxShadow: "none",
            }}
          >
            <MoreVertIcon
              onClick={handleActionsClick}
              style={{ cursor: "pointer", fontSize: "20px" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      <ModalWithTabs
        setWalletModal={setWalletModal}
        setAccountModal={setAccountModal}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        userId={selectedUser?.id || selectedUser?.userId || user[0]?.id || user[0]?.userId}
      />
      <WarningModal
        url={url}
        action={action}
        open={openConfirm}
        setOpen={setConfirm}
        user={selectedUser || user[0]}
        reload={getUsers}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={(e) => handleOption(e)}>
          Manage Profile
        </MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>
          Manage Accounts
        </MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>Manage KYC</MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>
          Login Tracker
        </MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>Activity Log</MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>
          Reset Credential
        </MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>
          {selectedUser?.isActive === true || (selectedUser?.isActive === undefined && (selectedUser?.status === "ACTIVE" || selectedUser?.customerStatus === "ACTIVE")) ? "Deactivate User" : "Activate User"}
        </MenuItem>
        <MenuItem onClick={(e) => handleOption(e)}>
          {selectedUser?.isAccountLocked === true || (selectedUser?.isAccountLocked === undefined && selectedUser?.accountLocked === true) ? "Unblock User" : "Block User"}
        </MenuItem>
      </Menu>
      <UploadSpreadSheetModal
        open={spreadSheetModal.open}
        setModal={setSpreadSheetModal}
        title={spreadSheetModal.title}
      />
      <MoreFormModal
        isOpen={modal.open}
        setModal={setModal}
        title={modal.title}
      />
      <MultipleFormModal
        modal={multipleFormModal}
        setModal={setMultipleFormModal}
      />
      <CreateWalletModal isOpen={walletModal.open} setModal={setWalletModal} />
      <CreateAccountModal
        isOpen={accountModal.open}
        setModal={setAccountModal}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="USERS MANAGEMENT"
          subtitle="Manage Users Information and Transactions"
        />
        <Box display="flex">
          <Searchbox handleSearch={handleSearch} />
          <Button
            onClick={(e) => toggleCreateUserMenu(e)}
            underline="none"
            sx={{
              backgroundColor: colors.orangeAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              marginLeft: "15px",
            }}
          >
            <AddIcon sx={{ mr: "10px" }} />
            Create Users
          </Button>

          <Menu
            id="basic-menu"
            anchorEl={createUserAnchorEl}
            open={createUserOpen}
            onClose={handleCreateUserClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          //   classes={{ paper: "dropdown-menu2" }}
          >
            <MenuItem onClick={(e) => handleOption(e)}>
              Create Single User
            </MenuItem>
            <MenuItem onClick={(e) => handleOption(e)}>
              Upload Spread Sheet
            </MenuItem>
            <MenuItem onClick={(e) => handleOption(e)}>
              Create Users with Forms
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      {/* Filters Section */}
      <Box
        display="flex"
        flexWrap="wrap"
        gap="15px"
        alignItems="center"
        mb="20px"
        p="15px"
        sx={{
          backgroundColor: colors.primary[400],
          borderRadius: "8px",
        }}
      >
        <Typography variant="h6" color={colors.grey[100]} sx={{ mr: "10px", fontWeight: "bold" }}>
          Filters:
        </Typography>

        <Box display="flex" gap="10px" flexWrap="wrap" flexGrow={1}>
          {/* User Type Filter */}
          <TextField
            select
            label="User Type"
            value={userType}
            onChange={(e) => {
              const val = e.target.value;
              setUserType(val);
              setPage(1); // Reset to page 1 on filter change
              if (val !== "CORPORATE") {
                setBusinessType("ALL");
              }
            }}
            variant="filled"
            size="small"
            sx={{ minWidth: "150px" }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="ALL">All Types</option>
            <option value="PERSONAL">Personal</option>
            <option value="CORPORATE">Corporate</option>
            <option value="ADMIN">Admin</option>
            <option value="MARKETER">Marketer</option>
          </TextField>

          {/* Business Type Filter */}
          <TextField
            select
            label="Business Type"
            value={businessType}
            onChange={(e) => {
              setBusinessType(e.target.value);
              setPage(1);
            }}
            disabled={userType !== "CORPORATE"}
            variant="filled"
            size="small"
            sx={{ minWidth: "180px" }}
            SelectProps={{
              native: true,
            }}
            helperText={userType !== "CORPORATE" ? "Only for CORPORATE type" : ""}
            FormHelperTextProps={{
              style: { color: colors.grey[300], fontSize: "10px", margin: "3px 0 0 0" }
            }}
          >
            <option value="ALL">All Business Types</option>
            <option value="CAC_BUSINESS">CAC Business</option>
            <option value="NON_CAC_BUSINESS">Non-CAC Business</option>
          </TextField>

          {/* Sort By Filter */}
          <TextField
            select
            label="Sort By"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            variant="filled"
            size="small"
            sx={{ minWidth: "150px" }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="createdAt">Date Created</option>
            <option value="firstName">First Name</option>
            <option value="surname">Last Name</option>
            <option value="email">Email</option>
          </TextField>

          {/* Sort Direction Filter */}
          <TextField
            select
            label="Direction"
            value={sortDirection}
            onChange={(e) => setSortDirection(e.target.value)}
            variant="filled"
            size="small"
            sx={{ minWidth: "120px" }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="DESC">Descending</option>
            <option value="ASC">Ascending</option>
          </TextField>

          {/* Status Filter */}
          <TextField
            select
            label="User Status"
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
            variant="filled"
            size="small"
            sx={{ minWidth: "130px" }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="ALL">All Statuses</option>
            <option value="ACTIVE">Active</option>
            <option value="PENDING">Pending</option>
            <option value="INACTIVE">Inactive</option>
            <option value="SUSPENDED">Suspended</option>
            <option value="LOCKED">Locked</option>
          </TextField>

          {/* KYC Status Filter */}
          <TextField
            select
            label="KYC Status"
            value={kycStatusFilter}
            onChange={(e) => {
              setKycStatusFilter(e.target.value);
              setPage(1);
            }}
            variant="filled"
            size="small"
            sx={{ minWidth: "140px" }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="ALL">All KYC Statuses</option>
            <option value="VERIFIED">Verified</option>
            <option value="PENDING">Pending</option>
            <option value="UNVERIFIED">Unverified</option>
          </TextField>

          {/* Gender Filter */}
          <TextField
            select
            label="Gender"
            value={genderFilter}
            onChange={(e) => {
              setGenderFilter(e.target.value);
              setPage(1);
            }}
            variant="filled"
            size="small"
            sx={{ minWidth: "110px" }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="ALL">All Genders</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>
          </TextField>
        </Box>

        <Button
          variant="contained"
          sx={{
            backgroundColor: colors.orangeAccent[700],
            color: colors.grey[100],
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: colors.orangeAccent[800],
            }
          }}
          onClick={() => {
            setUserType("ALL");
            setBusinessType("ALL");
            setStatusFilter("ALL");
            setKycStatusFilter("ALL");
            setGenderFilter("ALL");
            setSortBy("createdAt");
            setSortDirection("DESC");
            setSearch("");
            setPage(1);
          }}
        >
          Reset Filters
        </Button>
      </Box>

      {/* Active Search & Filters Info Bar */}
      {((search && search.trim() !== "") ||
        (userType && userType !== "ALL") ||
        (businessType && businessType !== "ALL") ||
        (statusFilter && statusFilter !== "ALL") ||
        (kycStatusFilter && kycStatusFilter !== "ALL") ||
        (genderFilter && genderFilter !== "ALL")) && (
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            mb="10px"
            p="8px 12px"
            sx={{
              backgroundColor: colors.primary[400],
              borderRadius: "4px",
              flexWrap: "wrap"
            }}
          >
            <Typography variant="body2" color={colors.grey[100]} sx={{ fontWeight: "bold" }}>
              Active Query:
            </Typography>
            {search && (
              <Box
                sx={{
                  backgroundColor: colors.orangeAccent[700],
                  color: "#white",
                  p: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                Search: "{search}"
              </Box>
            )}
            {userType !== "ALL" && (
              <Box
                sx={{
                  backgroundColor: colors.orangeAccent[700],
                  color: "#white",
                  p: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                Type: {userType}
              </Box>
            )}
            {businessType !== "ALL" && (
              <Box
                sx={{
                  backgroundColor: colors.orangeAccent[700],
                  color: "#white",
                  p: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                Business: {businessType}
              </Box>
            )}
            {statusFilter !== "ALL" && (
              <Box
                sx={{
                  backgroundColor: colors.orangeAccent[700],
                  color: "#white",
                  p: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                Status: {statusFilter}
              </Box>
            )}
            {kycStatusFilter !== "ALL" && (
              <Box
                sx={{
                  backgroundColor: colors.orangeAccent[700],
                  color: "#white",
                  p: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                KYC: {kycStatusFilter}
              </Box>
            )}
            {genderFilter !== "ALL" && (
              <Box
                sx={{
                  backgroundColor: colors.orangeAccent[700],
                  color: "#white",
                  p: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                Gender: {genderFilter}
              </Box>
            )}
          </Box>
        )}

      <Box
        m="8px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "#fff solid",
          },
          "& .name-column--cell": {
            color: colors.orangeAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.orangeAccent[200]} !important`,
          },
        }}
      >
        {!(
          (search && search.trim() !== "") ||
          (userType && userType !== "ALL") ||
          (businessType && businessType !== "ALL") ||
          (statusFilter && statusFilter !== "ALL") ||
          (kycStatusFilter && kycStatusFilter !== "ALL") ||
          (genderFilter && genderFilter !== "ALL")
        ) ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            sx={{
              backgroundColor: colors.primary[400],
              borderRadius: "8px",
              p: 3,
              textAlign: "center",
            }}
          >
            <Typography variant="h5" color={colors.orangeAccent[500]} sx={{ mb: 1, fontWeight: "bold" }}>
              Auditing Dashboard Ready
            </Typography>
            <Typography variant="body1" color={colors.grey[300]}>
              Please enter a search query (name, email, phone, account number, or ID) or select a filter from the panel above to load user records.
            </Typography>
          </Box>
        ) : (
          <DataGrid
            getRowId={(row) => {
              return row?.userId || row?.id || row?.loginId || row?.email || Math.random();
            }}
            rows={user[0] ? user : []}
            columns={columns}
            paginationMode="server"
            rowCount={totalRows}
            page={page - 1}
            pageSize={pageSize}
            onPageChange={(newPage) => setPage(newPage + 1)}
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize);
              setPage(1);
            }}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        )}
      </Box>
    </Box>
  );
};

export default ManageUser;
